export const markAsUnread = "hNa";
export const markAsUnreadNumberOfConversationsWhenCountIsNegative = "iNa";
export const markAsUnreadNumberOfItemsWhenCountIsNegative = "jNa";
export const markAsUnreadNumberOfConversations = "kNa";
export const markAsUnreadNumberOfItems = "lNa";
export default {markAsUnread,markAsUnreadNumberOfConversationsWhenCountIsNegative,markAsUnreadNumberOfItemsWhenCountIsNegative,markAsUnreadNumberOfConversations,markAsUnreadNumberOfItems};